import { Flex, Skeleton, Text, Tooltip } from '@chakra-ui/react'
import { ReactNode } from 'react'

import InfoIcon from '@/ui/assets/InfoIcon'

export default function MetricCard({
  icon,
  label,
  value,
  valueLabel,
  isLoading,
  info,
  detailText,
  complement
}: {
  icon: ReactNode
  label: string
  value: number | string | undefined
  valueLabel?: string
  isLoading?: boolean
  info?: React.ReactNode
  detailText?: string
  complement?: string
}) {
  return (
    <Flex
      borderWidth={'1px'}
      borderColor={'custom.gray.600'}
      borderRadius={'4px'}
      direction={'column'}
      gap={2}
      w={'full'}
      p={4}
      justify={'space-between'}
      position={'relative'}
    >
      {!!info && (
        <Tooltip label={info}>
          <Flex position={'absolute'} top={'3'} right={'3'}>
            <InfoIcon color={'custom.gray.300'} h={'24px'} w={'24px'} />
          </Flex>
        </Tooltip>
      )}
      <Flex direction={'column'} gap={2}>
        {icon}
        <Text color={'custom.gray.300'} fontSize={'16'} fontWeight={400}>
          {label}
        </Text>
      </Flex>
      <Flex gap={1} align={'baseline'}>
        <Flex gap={1} align={'baseline'}>
          <Skeleton isLoaded={!isLoading} minW="18px">
            <Text color={'custom.gray.100'} fontSize={'24'} fontWeight={600}>
              {value}
            </Text>
          </Skeleton>
          {complement && (
            <Text color={'custom.gray.300'} fontSize={'14'} fontWeight={400}>
              {complement}
            </Text>
          )}
        </Flex>
        {!!valueLabel && (
          <Text color={'custom.gray.300'} fontSize={'14'} fontWeight={400}>
            {valueLabel}
          </Text>
        )}
      </Flex>
      {!!detailText && (
        <Text color={'custom.gray.300'} fontSize={'14'} fontWeight={400}>
          {detailText}
        </Text>
      )}
    </Flex>
  )
}
